// extracted by mini-css-extract-plugin
export default {"tag":"styles_tag__SC1Oz","tagPrimary":"styles_tagPrimary__2g1lU","tagSecondary":"styles_tagSecondary__8Qh31"};